import React, { Component } from 'react'
import Lottie from 'react-lottie'
import * as animationData from '../assets/building-animation.json'

class BuildingAnimation extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      isStopped: true,
      isPaused: false,
      speed: 1,
      direction: 1,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    }
    return (
      <div>
        <Lottie options={defaultOptions} />
      </div>
    )
  }
}

export default BuildingAnimation



// WEBPACK FOOTER //
// ./src/components/buildingAnimation.js